
const parseTime = (time) => {
  const min = Math.floor(time);
  const sec = Math.floor(((time * 100) % 100) * 0.6);

  if (min === 0)
    return(sec + ' sec');
  if (sec === 0)
    return(min + ' min');

  return min + ' min, ' + sec + ' sec';
}


export const formatterTimes = (value, context) => {
  return parseTime(value);
}




// WEBPACK FOOTER //
// ./src/common/Chart/utils.js